import { apiClient, type PageEnvelope } from '@/lib/api-client';

export interface LeadList {
  id: string;
  name: string;
  description: string | null;
  total_leads: number;
  main_vertical: string | null;
  sub_vertical: string | null;
  source: string | null;
  created_at: string;
}

export interface Lead {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  company: string | null;
  title: string | null;
  description: string | null;
  status: string;
  main_vertical: string | null;
  sub_vertical: string | null;
  custom_fields: Record<string, unknown>;
  created_at: string;
}

export interface LeadPage {
  items: Lead[];
  page: number;
  limit: number;
  total: number;
  total_pages: number;
}

export interface ImportResult {
  submitted: number;
  imported: number;
  duplicates: number;
  skipped: number;
  total: number;
}

export interface LeadStats {
  total: number;
  by_status: Record<string, number>;
  by_vertical: Record<string, number>;
}

export const leadListsApi = {
  list: () =>
    apiClient.get<PageEnvelope<LeadList>>('/api/v1/lists').then((r) => r.items),
  detail: (id: string) => apiClient.get<LeadList>(`/api/v1/lists/${id}`),
  create: (input: { name: string; description?: string }) =>
    apiClient.post<LeadList>('/api/v1/lists', input),
  /**
   * Page-numbered. `page` starts at 1; `limit` defaults to 100 server-side.
   * Returns { items, page, limit, total, total_pages }.
   */
  leadsIn: (
    id: string,
    params: { page?: number; limit?: number; status?: string } = {},
  ) =>
    apiClient.get<LeadPage>(`/api/v1/lists/${id}/leads`, params),
  stats: (id: string) => apiClient.get<LeadStats>(`/api/v1/lists/${id}/stats`),
  import: (id: string, leads: Array<Partial<Lead> & { email: string }>) =>
    apiClient.post<ImportResult>(`/api/v1/lists/${id}/import`, { leads }),
  emptyList: (id: string) => apiClient.del<{ deleted: number }>(`/api/v1/lists/${id}/leads`),
};
